import { TDocumentDetails } from '../../apis/documents/documents.interfaces';
import { mockUserAction } from '../users/userAction';

export const mockDocumentDetails: TDocumentDetails = {
  basic_details: {
    _id: 'doc-123',
    name: 'Birth Certificate - Kavita Reddy',
    type: 'birth_certificate',
    size: 245678,
    s3_key: 'documents/student-123/birth-cert-kavita-reddy.pdf',
    thumbnail_key: 'documents/student-123/birth-cert-kavita-reddy-thumb.jpg',
    is_verifiable: true,
    verified: true,
    verified_at: new Date('2025-11-10T12:00:00.000Z'),
    verification_notes: 'Document verified successfully against original certificate. All details match.',
    rejection_reason: undefined,
  },
  owner: {
    owner_type: 'student',
    owner_id: 'student-123',
    owner_name: 'Kavita Reddy',
    owner_details: {
      student_id: 'student-123',
      enrollment_date: '2025-01-15T00:00:00.000Z',
      academic_year: 2025,
      status: 'active',
      grade: '10',
      section: 'A',
    },
  },
  verifier: {
    _id: 'admin-456',
    first_name: 'Priya',
    last_name: 'Sharma',
    email: 'priya.sharma@institute.edu',
  },
  institute: {
    _id: 'inst-789',
    name: 'Delhi Public School',
  },
  action: {
    created_at: new Date('2025-11-01T10:00:00.000Z'),
    created_by: mockUserAction.userId,
    updated_at: new Date('2025-11-10T12:00:00.000Z'),
    updated_by: 'admin-456',
  },
};
